import React from 'react';
import styled from 'styled-components';
import { FiBook } from 'react-icons/fi';

const SelectContainer = styled.div`
  position: relative;
  min-width: 200px;
  flex: 1 1 240px;
  min-width: 0;
  
  @media (max-width: 768px) {
    min-width: 150px;
    flex: 1 1 220px;
  }
  
  @media (max-width: 640px) {
    min-width: 100%;
    flex: 1 1 100%;
  }
  
  @media (max-width: 480px) {
    min-width: 100px;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 10px 40px 10px 14px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background: var(--background-primary);
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  height: 44px;
  appearance: none;

  &:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(120, 53, 15, 0.2);
  }

  &:disabled {
    background: var(--background-secondary);
    color: var(--text-muted);
    cursor: not-allowed;
  }
  
  @media (max-width: 640px) {
    height: 40px;
    padding: 8px 36px 8px 12px;
    font-size: 13px;
  }
  
  @media (max-width: 480px) {
    height: 36px;
    padding: 6px 32px 6px 10px;
    font-size: 12px;
  }
  
  @media (max-height: 600px) {
    height: 40px;
    padding: 8px 36px 8px 12px;
    font-size: 13px;
  }
  
  @media (max-height: 500px) {
    height: 36px;
    padding: 6px 32px 6px 10px;
    font-size: 12px;
  }
`;

const SelectIcon = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
  
  @media (max-width: 640px) {
    right: 12px;
  }
  
  @media (max-width: 480px) {
    right: 10px;
  }
  
  @media (max-height: 600px) {
    right: 12px;
  }
  
  @media (max-height: 500px) {
    right: 10px;
  }
`;

export default function CourseSelect({ value, onChange, courses = [], disabled = false, placeholder = "Select course..." }) {
  return (
    <SelectContainer>
      <Select
        value={value || ''}
        onChange={(e) => onChange(parseInt(e.target.value) || null)}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        {courses.map(course => (
          <option key={course.id} value={course.id}>
            {course.code} - {course.name}
          </option>
        ))}
      </Select>
      <SelectIcon>
        <FiBook size={16} />
      </SelectIcon>
    </SelectContainer>
  );
}
